<template>
    <div class="columns">
        <div class="column is-one-fifth">
            <aside class="menu">
                <p class="menu-label">
                    Game providers
                </p>
                <ul class="menu-list">
                    <li>
                        <router-link :to="{ name: 'client-settings-bk' }" active-class="is-active"><a>Bookmaker</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-flg' }" active-class="is-active"><a>FLG</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-hdraces' }" active-class="is-active"><a>HdRaces</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-redpipe' }" active-class="is-active"><a>RedPipe</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-tvbet' }" active-class="is-active"><a>TVBet</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-softgamings' }" active-class="is-active"><a>SoftGamings</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-aviatrix' }" active-class="is-active"><a>Aviatrix</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-galaxsys' }" active-class="is-active"><a>Galaxsys</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-smartsoft' }" active-class="is-active"><a>SmartSoft</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-mascot' }" active-class="is-active"><a>Mascot</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-vegas' }" active-class="is-active"><a>Vegas</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-boldplay' }" active-class="is-active"><a>Boldplay</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-baas' }" active-class="is-active"><a>Baas</a></router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-doublechancelotto' }" active-class="is-active"
                            ><a>DoubleChanceLotto</a></router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'client-settings-betconstruct' }" active-class="is-active"
                            ><a>BetConstruct</a></router-link
                        >
                    </li>
                </ul>
            </aside>
        </div>
        <div class="column">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: 'client-settings-game-providers'
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/game-providers.vue